import { api } from "../api";

type Page = "countries" | "localizations" | "categories" | "locales" | "diagnostics" | "settings";

const TABS: { hash: string; label: string; page: Page }[] = [
  { hash: "#/countries", label: "Countries", page: "countries" },
  { hash: "#/localizations", label: "Localizations", page: "localizations" },
  { hash: "#/categories", label: "Categories", page: "categories" },
  { hash: "#/locales", label: "Locales", page: "locales" },
  { hash: "#/diagnostics", label: "Diagnostics", page: "diagnostics" },
  { hash: "#/settings", label: "Settings", page: "settings" },
];

export default function Header({
  active,
  onLogout,
}: {
  active: Page;
  onLogout?: () => void;
}) {
  async function logout() {
    try {
      await api.logout();
    } finally {
      onLogout?.();
    }
  }
  return (
    <header className="border-b border-gh-border bg-gh-surface px-6 py-3">
      <div className="flex items-center gap-6">
        <h1 className="text-lg font-semibold">Flags CMS</h1>
        <nav className="flex gap-1">
          {TABS.map((t) => (
            <a
              key={t.page}
              href={t.hash}
              className={`px-3 py-1 rounded text-sm ${
                active === t.page
                  ? "bg-gh-bg text-gh-text font-medium"
                  : "text-gh-muted hover:bg-gh-bg"
              }`}
            >
              {t.label}
            </a>
          ))}
        </nav>
        <button
          type="button"
          data-testid="logout-button"
          onClick={logout}
          className="ml-auto px-3 py-1 rounded text-sm text-gh-muted hover:bg-gh-bg"
        >
          Logout
        </button>
      </div>
    </header>
  );
}
